import React, { Component } from "react";
import { Wrapper, Card } from "app/NativeComponents/common";
import { ColorPicker } from "app/NativeComponents/snippets";
import { store } from "app/store";
class PrimaryColor extends Component {
  render() {
    const device = store.getState().native.device;

    if (this.props.template.html_template.default_primary_color.hex != null) {
      return (
        <Card>
          <ColorPicker
            ref_name={"primary_color"}
            placeholder={
              this.props.template.html_template.default_primary_color.title
            }
            onChange={value => {
              if (device == "desktop" && value.hex) {
                this.props.updateTemplate({
                  prop: "primary_color",
                  value: value.hex
                });
              } else {
                this.props.updateTemplate({
                  prop: "primary_color",
                  value
                });
              }
            }}
            value={
              this.props.template.primary_color != null
                ? this.props.template.primary_color
                : this.props.template.html_template.default_primary_color.hex
            }
            onColorSelect={() => {}}
            {...this.props}
          />
        </Card>
      );
    }

    return <Wrapper />;
  }
}

export default PrimaryColor;
